import { useState } from 'react';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.recamix.com';

export const usePdfApi = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);

  const analyzePDF = async (file, options) => {
    try {
      setLoading(true);
      setError(null);
      console.log('1. PDF 분석 시작:', file.name, file.type, file.size);

      const formData = new FormData();
      formData.append('file', file);
      formData.append('options', JSON.stringify(options));

      const response = await fetch(`${process.env.REACT_APP_API_URL}/analyze-pdf`, {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        throw new Error('PDF 분석 실패');
      }

      const data = await response.json();
      console.log('6. API 응답 데이터:', data);

      if (!data.success || !data.result.success) {
        throw new Error(data.error || '분석 결과를 가져올 수 없습니다');
      }

      const resultData = data.result.data;  // 응답 구조에 맞게 데이터 추출
      setResult(resultData);
      return resultData;

    } catch (error) {
      console.error('9. 오류 발생:', error);
      setError(error.message);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const handleAnalyzePDF = async (file, options) => {
    setLoading(true);
    setError(null);
    try {
      const response = await analyzePDF(file, options);
      setResult(response);
    } catch (error) {
      setError(error.message);
      console.error('PDF 분석 중 오류:', error);
    } finally {
      setLoading(false);
    }
  };

  const clearError = () => setError(null);

  return {
    loading,
    error,
    result,
    analyzePDF: handleAnalyzePDF,
    clearError
  };
};